import { isEmpty } from 'lodash';
import {
    validateEmail,
} from '../../utils/validations';

function useBillingValidations (props) {
    const {
        chargifyInput,
        setInputErrors,
        inputErrors,
        getNamespaceTouches,
    } = props;

    const {
        firstName,
        lastName,
        email,
    } = chargifyInput;

    function isFirstNameValid (err) {
        const t = getNamespaceTouches('useBillingErrors');
        if (t.firstName) {
            if (firstName && !isEmpty(firstName.trim())) {
                delete err.firstName;
                return true;
            } else {
                err.firstName = 'First name is required.';
                return false;
            }
        }
        return false;
    }

    function isLastNameValid (err) {
        const t = getNamespaceTouches('useBillingErrors');
        if (t.lastName) {
            if (lastName && !isEmpty(lastName.trim())) {
                delete err.lastName;
                return true;
            } else {
                err.lastName = 'Last name is required.';
                return false;
            }
        }

        return false;
    }

    function isEmailValid (err) {
        const t = getNamespaceTouches('useBillingErrors');
        if (t.email) {
            const trimmedEmail = email ? email.trim() : '';
            if (email && isEmpty(email.trim())) {
                err.email = 'Email is required.';
                return false;
            } else if (!validateEmail(trimmedEmail)) {
                err.email = 'Email format is incorrect.';
                return false;
            } else {
                delete err.email;
                return true;
            }
        }
        return false;
    }

    function isCardUserInfoValid () {
        let valid = true;
        const err = { ...inputErrors };
        if (!isFirstNameValid(err)) valid = false;
        if (!isLastNameValid(err)) valid = false;
        if (!isEmailValid(err)) valid = false;
        setInputErrors({ ...err });
        return valid;
    }

    return {
        isCardUserInfoValid,
    };
}

export default useBillingValidations;
